import type { MicroInverters } from '~/types/equipment';

import installationRiskHttp from '~/services/installation-risk-api/installation-risk-api.http';

class MicroInvertersService {
  private readonly endpoint = '/v1/microinverters';

  private static buildQueryString(params: MicroInverters.GetMicroInvertersRequest): string {
    const searchParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        searchParams.append(key, value.toString());
      }
    });

    return searchParams.toString();
  }

  async create(data: MicroInverters.CreateMicroInverterRequest): Promise<MicroInverters.MicroInverter> {
    const response = await installationRiskHttp.post(this.endpoint, data);
    return response.data;
  }

  async getById(id: number): Promise<MicroInverters.MicroInverter> {
    const response = await installationRiskHttp.get(`${this.endpoint}/${id}`);
    return response.data;
  }

  async list(params: MicroInverters.GetMicroInvertersRequest): Promise<MicroInverters.GetMicroInvertersResponse> {
    const queryString = MicroInvertersService.buildQueryString(params);
    const url = queryString ? `${this.endpoint}?${queryString}` : this.endpoint;
    const response = await installationRiskHttp.get(url);
    return response.data;
  }

  async update(id: number, data: MicroInverters.UpdateMicroInverterRequest): Promise<MicroInverters.MicroInverter> {
    const response = await installationRiskHttp.put(`${this.endpoint}/${id}`, data);
    return response.data;
  }
}

const microInvertersService = new MicroInvertersService();
export default microInvertersService;
